import { InvoiceStatus } from '@ducat-pro-anapi/swag-anapi-v2';

export const OPTION_LABELS: { [N in InvoiceStatus.StatusEnum] } = {
    paid: 'paid',
    cancelled: 'cancelled',
    fulfilled: 'fulfilled',
    unpaid: 'unpaid',
};
